import React from 'react';
import styled, { css } from 'styled-components';

import { DetailedCarColorProps } from '@/components/DetailedCarColor/DetailedCarColor.types';
import { colors } from '@/constants/theme';

function DetailedCarColor({ hex, label, isMobile }: DetailedCarColorProps) {
  return (
    <Component>
      <Color hex={hex} isMobile={isMobile} />
      <Label isMobile={isMobile}>{label}</Label>
    </Component>
  );
}

export default DetailedCarColor;

const Component = styled.div`
  display: flex;
  align-items: center;
`;

const Color = styled.div<{ hex: string; isMobile?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid ${colors.gray300};
  margin-right: 10px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      width: 18px;
      height: 18px;
    `}
  ${({ hex }) =>
    hex &&
    css`
      background-color: ${hex};
    `}
`;

const Label = styled.div<{ isMobile?: boolean }>`
  font-size: 18px;
  color: ${(props) => props.theme.black};

  ${({ isMobile }) =>
    isMobile &&
    css`
      font-size: 14px;
    `}
`;
